var _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilePdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 48",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pdfTitle"
  }, "PDF File") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "pdfTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0v48h23c7.2,0,13-5.8,13-13V0H0z M34,35c0,6.1-4.9,11-11,11H2V2h32V35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.1 34.8h1.7c1.2 0 2 0.4 2 1.6s-0.9 1.7-2 1.7h-0.7v1.9h-1v-5.2zm1.6 2.5c0.8 0 1.1-0.3 1.1-0.9s-0.4-0.9-1.2-0.9h-0.6v1.8h0.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.8 34.8h1.4c1.6 0 2.6 0.9 2.6 2.6s-1 2.6-2.5 2.6h-1.4v-5.2zm1.3 4.4c1 0 1.6-0.6 1.6-1.9s-0.6-1.8-1.6-1.8h-0.4v3.7h0.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8,34.8h3.2v0.8h-2.2V37h1.9v0.8h-1.9V40h-1V34.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10.1 12 25.9 12 25.9 9.8 10.1 9.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.1 20.2 25.9 20.2 25.9 18 10.1 18"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "10.1 28.5 22.1 28.5 22.1 26.2 10.1 26.2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file-pdf.a4179f1c00a7431374bdbd8f2d7a0eee.svg";
export { ForwardRef as ReactComponent };